export class Announcement {
    id: string;
    text: string;
    date: Date;
    doctorName: string;
    doctorSurname: string;
    giorno: number;
    mese: number;
    anno: number;

  
  
    // tslint:disable-next-line:max-line-length
    constructor(text: string) {
      this.text = text;
    }
  }
  